<template>
        <div>                        
            <span class="text-muted">New images</span>
            <div class="d-flex flex-row overflow-scroll" style="max-height: 300px">        
    
                <!-- selected images -->               
                <input class="d-none" type="checkbox" checked
                    v-for="image in images" :key="`image_id${image.id}`"
                    :id="`image_${image.id}_checkbox`" :value="image.id" v-model="unselected_images">                
                <div v-for="image in images" :key="image.id" @click="unselectImage(image.id)"
                    :id="`image_${image.id}_card`"
                    class="ml-3 image-draft card shadow d-flex flex-column justify-content-center" 
                    style="min-width:15rem ">                                      
                    <img :src="image.image" alt="" class="card-img" style="max-height: 100%; object-fit: contain">
                </div>
    
                 <!-- image selector -->
                 <div class="ml-3 base-image-input " @click="fileSelectorclicked" style="min-width: 15rem">        
                        <span v-if="!imageData" class="placeholder">
                            Choose Images
                        </span>
                        <input  class="file-input" ref="fileInput" type="file" @input="onSelectFile" 
                        accept="image/jpeg" multiple>
                </div>
            </div>
            <!-- image count -->
            <div class="mt-2">
                <small>{{selected_images.length}} chosen</small>
            </div>
        </div>
    </template>
    <script>
    export default {
      data () {
        return {
          imageData: null,
          images: [],
          selected_images:[],
          unselected_images:[]
        }
      },
      watch:{
        unselected_images: function(){              
            if (this.unselected_images.length){
                var selected_images = this.images
                for (var el in this.unselected_images){                
                    var image_id = this.unselected_images[el]
                    //retrieve selected images from unselected images data
                    selected_images = selected_images.filter(obj => {
                        return obj.id != image_id
                    })                
                }
                this.selected_images = selected_images            
            }else{
                this.selected_images = this.images              
            }
        },
        selected_images: function(){
            //if selected images then emit to v-model in parent
            if (this.selected_images.length){
                var dataObject = this.selected_images
                var dataArray = []
                //get file
                for(var i in dataObject) {
                    dataArray.push(dataObject[i].file)
                }
                this.$emit('input', dataArray)
            }
        }    
      },
      methods: {
        //when the select images div is clicked, manually click the hidden file input 
        fileSelectorclicked () {
            this.images = []
            this.$refs.fileInput.click()
        },
        //remove image from list of selected images
        unselectImage (image_id){
            var checkbox = document.getElementById(`image_${image_id}_checkbox`)
            var card = document.getElementById(`image_${image_id}_card`)        
            checkbox.click() 
    
            if (card.classList.contains("border-0")){
                card.classList.remove("border-0")
                card.classList.add("shadow")
            }else{
                card.classList.add("border-0")
                card.classList.remove("shadow")
            }           
          
        },
        onSelectFile () {
            const input = this.$refs.fileInput
            const files = input.files        
                
            for (var i=0; i < 5; i++ ){                                              
                const reader = new FileReader
                reader.file = files[i]
                reader.id = i //give the reader an id for v-bind on multiple image for loop
                reader.onload = e => {                     
                    this.images.push({'id':reader.id,'image': e.target.result ,'file':reader.file})
                    this.selected_images = this.images
                }  
                reader.readAsDataURL(files[i])                                              
            }
        }
      }
    }
    </script>
    <style scoped>
    .base-image-input {
        display: block;
        width: 200px;
        height: 300px;
        cursor: pointer;
        background-size: cover;
        background-position: center center;
    }
    .image-draft {
        cursor: pointer;
    }
    .placeholder {
        background: #F0F0F0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333;
        font-size: 18px;
        font-family: Helvetica;
        border-radius: 5px;
    }
    .placeholder:hover {
        background: #E0E0E0;
    }
    .file-input {
        display: none;
    }
    </style>